import { gql } from '@apollo/client';

export const FETCH_SERVICE_RESERVATIONS = gql`
  query fetchPrenotazioni($where: Service_reservationWhereInput, $limit: Int!) {
    service_reservations(first: $limit, where: $where) {
      edges {
        node {
          objectId
          stato
          stato_conferma
          createdAt
          stato_prenotazione
          centro_servizi_pointer {
            objectId
            nome
          }
          join_servizi_service_reservation {
            edges {
              node {
                objectId
                metadata
                order
                servizi_pointer {
                  objectId
                  nome
                  nome_api
                  img {
                    url
                  }
                  loadInGiotto
                  width
                  height
                  categorie_servizi_pointer {
                    objectId
                    nome_categoria
                    servizi_offerti_default_pointer {
                      objectId
                      nome
                    }
                  }
                }
              }
            }
          }
          stati_tipologie {
            ... on Element {
              value
            }
          }
          contatori {
            ... on Element {
              value
            }
          }
          prestazioni {
            edges {
              node {
                objectId
                nome
                categorie_servizi_pointer {
                  objectId
                  nome_categoria
                  servizi_offerti_default_pointer {
                    objectId
                    nome
                  }
                }
              }
            }
          }
          servizi_offerti_default_relation {
            edges {
              node {
                objectId
                nome
                order
              }
            }
          }
          risorse_associate_relation {
            edges {
              node {
                objectId
                category
                necrofori {
                  edges {
                    node {
                      objectId
                      nome
                      cognome
                      ruolo
                    }
                  }
                }
                automezzi_reservation_relation {
                  edges {
                    node {
                      objectId
                      from
                      to
                      servizi_offerti_pointer {
                        objectId
                      }
                      automezzi_pointer {
                        objectId
                      }
                      service_reservation_pointer {
                        objectId
                      }
                    }
                  }
                }
                personale_reservation_relation {
                  edges {
                    node {
                      objectId
                      description
                      ruolo
                      from
                      to
                      servizi_offerti_pointer {
                        objectId
                      }
                      service_reservation_pointer {
                        objectId
                      }
                      personale_pointer {
                        objectId
                        ruolo
                        cognome
                        nome
                        email
                        cellulare
                        codice_fiscale
                        related_user_pointer {
                          objectId
                          first_name
                          last_name
                        }
                        org_pointer {
                          objectId
                          nome
                        }
                      }
                      defunto_pointer {
                        objectId
                        forno
                        cimitero
                        cognome
                        nome
                      }
                    }
                  }
                }
                automezzi {
                  edges {
                    node {
                      objectId
                      marca
                      modello
                      targa
                    }
                  }
                }
              }
            }
          }
          metadata
          defunto_pointer {
            nome
            forno
            cimitero
            cognome
            objectId
            company_pointer {
              objectId
              nome
            }
          }
          cliente_pointer {
            cognome
            objectId
          }
          org_pointer {
            objectId
            nome
          }
          ACL {
            public {
              read
              write
            }
            roles {
              roleName
              read
              write
            }
          }
        }
      }
    }
  }
`;
